import { lazy, Suspense } from 'react'

import { createFileRoute } from '@tanstack/react-router'

import { ErrorBoundary } from '@/components/common/error-boundary'
import { Skeleton } from '@/components/ui/skeleton'

const DetailsHistoryNotes = lazy(
	() =>
		import('@/features/air/case-management/components/details/history/notes'),
)

export const Route = createFileRoute(
	'/_dashboard/air/case-management/$id/discussion',
)({
	head: ({ params }) => ({
		meta: [
			{
				title: `Discussion · Case ${params.id} | Case Management | BitLyft AIR®`,
			},
		],
	}),
	component: RouteComponent,
})

function RouteComponent() {
	const { id } = Route.useParams()

	return (
		<div className="flex w-full flex-col gap-4">
			<h3 className="text-lg font-bold">Discussion</h3>

			<ErrorBoundary
				feature="case-management"
				section="discussion"
				entityId={id}
			>
				<Suspense fallback={<Skeleton className="h-32 w-full" />}>
					<DetailsHistoryNotes id={id} />
				</Suspense>
			</ErrorBoundary>
		</div>
	)
}
